import React from 'react'
import { Link } from 'react-router-dom'
import { ToolkitPageLayout } from '../../../components'
import { CommunityResourcesPlaceholderImage } from 'assets'

interface Breadcrumb {
  label: string
  path: string
}

export const LimitedScdProvidersPage: React.FC = () => {
  const pageTitle = 'Limited SCD Providers'
  const breadcrumbs: Breadcrumb[] = [
    { label: 'Toolkit', path: '/toolkit' },
    { label: 'Community', path: '/toolkit/community' }, // TODO: Create a CommunitySectionPage and link here
    { label: pageTitle, path: '/toolkit/community/limited-scd-providers' }
  ]

  const communityEducationalMaterialsLink =
    '/toolkit/community/community-educational-materials' // New page
  const localCommunityResourcesLink =
    'https://sicklecelldisease.net/resources-educational-materials/' // External link

  return (
    <ToolkitPageLayout title={pageTitle} breadcrumbs={breadcrumbs}>
      <div className="prose max-w-none text-[#3C2416]">
        <p className="text-lg italic text-center mb-12">
          Addressing the challenge of limited SCD providers requires a
          multifaceted approach, including enhancing education and connecting
          with available resources.
        </p>

        <div className="grid md:grid-cols-2 gap-8 mb-12">
          {/* Community Educational Materials */}
          <div className="p-6 border border-gray-200 rounded-lg shadow-md bg-white text-center flex flex-col justify-between">
            <div>
              <Link
                to={communityEducationalMaterialsLink}
                className="hover:opacity-80 transition-opacity"
              >
                <img
                  src={CommunityResourcesPlaceholderImage}
                  alt="Community Educational Materials"
                  className="max-w-full h-auto rounded-md shadow-sm inline-block mb-4"
                />
              </Link>
              <h3 className="text-xl font-semibold text-[#142841] mb-2">
                Community Educational Materials
              </h3>
            </div>
            <Link
              to={communityEducationalMaterialsLink}
              className="mt-4 inline-block bg-[#A6410A] hover:bg-[#894d35] text-white rounded-md px-4 py-2 text-base font-medium transition-colors duration-200 shadow-sm"
            >
              Learn More
            </Link>
          </div>

          {/* Local Community Resources */}
          <div className="p-6 border border-gray-200 rounded-lg shadow-md bg-white text-center flex flex-col justify-between">
            <div>
              <a
                href={localCommunityResourcesLink}
                target="_blank"
                rel="noopener noreferrer"
                className="hover:opacity-80 transition-opacity"
              >
                <img
                  src={CommunityResourcesPlaceholderImage}
                  alt="Local Community Resources"
                  className="max-w-full h-auto rounded-md shadow-sm inline-block mb-4"
                />
              </a>
              <h3 className="text-xl font-semibold text-[#142841] mb-2">
                Local Community Resources
              </h3>
            </div>
            <a
              href={localCommunityResourcesLink}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-4 inline-block bg-[#A6410A] hover:bg-[#894d35] text-white rounded-md px-4 py-2 text-base font-medium transition-colors duration-200 shadow-sm"
            >
              Visit Site
            </a>
          </div>
        </div>

        <hr className="my-12" />

        {/* All Done Button */}
        <div className="mt-12 mb-8 text-center">
          {/* TODO: Update to link to '/toolkit/community' once CommunitySectionPage is created */}
          <Link
            to="/toolkit"
            className="bg-[#A6410A] hover:bg-[#894d35] text-white rounded-md px-6 py-3 text-lg font-medium transition-colors duration-200 shadow-md hover:shadow-lg"
          >
            All done? Click here to return to the Toolkit home
          </Link>
        </div>
      </div>
    </ToolkitPageLayout>
  )
}
